import { CircleHelp } from 'lucide-react';

import { AutoneTooltip } from '../../tailwind';

interface DisabledReasonIconProps {
  disabledReason: string;
  container?: Element;
}

export const DisabledReasonIcon = ({
  disabledReason,
  container,
}: DisabledReasonIconProps) => {
  return (
    <div
      className="pointer-events-auto"
      // Ensure that clicking on the tooltip icon
      // does not select the MenuItem
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <AutoneTooltip
        text={disabledReason}
        side="right"
        sideOffset={20}
        className="max-w-50"
        container={container}
        asChild
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <CircleHelp className="h-4 w-4" />
      </AutoneTooltip>
    </div>
  );
};
